module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/logos/brand/intercom-fbfcb8b96b25bc6c7b28b170fbf3976a.svg";